import FooterPrimary from "../footerPrimary/footerPrimary"

function FooterSecondary() {
    return (
        <div className="web-footer-secondary">
            <div className="web-footer-secondary__container container">
                This site is for web development training & educational purpose only
            </div>
        </div>
    )
}

export default FooterSecondary;